var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoPersonnelColor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 138.06 31.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#07274a;}.cls-2{fill:#00b189;}.cls-3{fill:#102749;}.cls-4{fill:#176385;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2630",
    "data-name": "Group 2630"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2626",
    "data-name": "Group 2626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2625",
    "data-name": "Group 2625"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3847",
    "data-name": "Path 3847",
    className: "cls-1",
    d: "M46.42,9.19a2.92,2.92,0,0,1-.33.15L44.24,10a3.89,3.89,0,0,0-3-2.1,4,4,0,0,0-2.63.46,4.18,4.18,0,0,0-1.76,5A4.09,4.09,0,0,0,41.5,16c1.56-.25,2.84-1.73,2.76-2.78H40.08c0-.76,0-1.45,0-2.14A51.83,51.83,0,0,1,46.77,11a6.47,6.47,0,0,1-.05,2.48,6,6,0,0,1-6.09,4.91A6.44,6.44,0,0,1,39,5.67a7.09,7.09,0,0,1,5.2.79A4.81,4.81,0,0,1,46.42,9.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3848",
    "data-name": "Path 3848",
    className: "cls-1",
    d: "M65,4.9h2.29c.08.78,0,1.55,0,2.32s0,1.5,0,2.34c.24-.12.39-.18.53-.26a4.62,4.62,0,0,1,7,3.82,5.12,5.12,0,0,1-.52,2.77,4.59,4.59,0,0,1-6.16,2c-.26-.12-.5-.27-.79-.42l-.15.57H65.06C64.93,17.59,64.89,5.94,65,4.9Zm7.53,8.65a2.54,2.54,0,0,0-1.77-2.67,2.59,2.59,0,0,0-3.24,1.68A2.68,2.68,0,0,0,69,16.05l.14.05a2.5,2.5,0,0,0,3.4-2.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3849",
    "data-name": "Path 3849",
    className: "cls-1",
    d: "M138.06,12.33a7.08,7.08,0,0,1-.8,3.61,4.52,4.52,0,0,1-4.35,2.51,4.41,4.41,0,0,1-4.12-2.77A7.63,7.63,0,0,1,128.85,9a4.59,4.59,0,0,1,5.63-2.47A4.46,4.46,0,0,1,137.32,9,6.94,6.94,0,0,1,138.06,12.33Zm-2.4.07a4.93,4.93,0,0,0-.54-2.58,2.22,2.22,0,0,0-2.92-1.14,2.17,2.17,0,0,0-1.14,1.13,5.31,5.31,0,0,0-.58,2.77,4.8,4.8,0,0,0,.63,2.48,2.21,2.21,0,0,0,1.73,1.2A2.16,2.16,0,0,0,135,15.13a4.74,4.74,0,0,0,.66-2.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3850",
    "data-name": "Path 3850",
    className: "cls-1",
    d: "M115,12.36a7.33,7.33,0,0,1-.57,3.14,4.75,4.75,0,0,1-6.2,2.62,3.93,3.93,0,0,1-.68-.34,5,5,0,0,1-2.1-2.74,8.21,8.21,0,0,1,0-5.23,4.76,4.76,0,0,1,9.14-.16A7.17,7.17,0,0,1,115,12.36Zm-2.38-.07A4.85,4.85,0,0,0,112,9.76a2.21,2.21,0,0,0-2-1.27,2.24,2.24,0,0,0-2,1.27,5.15,5.15,0,0,0-.61,2.43A5.3,5.3,0,0,0,108,15a2.2,2.2,0,0,0,1.77,1.25,2.13,2.13,0,0,0,2-1A5,5,0,0,0,112.61,12.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3851",
    "data-name": "Path 3851",
    className: "cls-1",
    d: "M126.56,12a7.54,7.54,0,0,1-1.21,4.57,4.7,4.7,0,0,1-6.57,1,4.88,4.88,0,0,1-1.13-1.18,6,6,0,0,1-1-2.65,8.31,8.31,0,0,1,.48-4.44,4.75,4.75,0,0,1,9,.49A18.22,18.22,0,0,1,126.56,12Zm-7.65.39c.07.53.11,1.06.23,1.57a4.41,4.41,0,0,0,.43,1.11,2.16,2.16,0,0,0,2.87,1.07,2.13,2.13,0,0,0,1-1,5.5,5.5,0,0,0,0-5.47,2.07,2.07,0,0,0-1.06-1,2.14,2.14,0,0,0-2.6.74,5,5,0,0,0-.89,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3852",
    "data-name": "Path 3852",
    className: "cls-1",
    d: "M83.53,9.56,83.62,9H86v9.09H83.63l-.1-.49a16.34,16.34,0,0,1-1.81.67A4.54,4.54,0,0,1,76.2,15a4.76,4.76,0,0,1-.11-.64,5,5,0,0,1,1.3-4.3,4.61,4.61,0,0,1,5.5-.82C83.09,9.3,83.28,9.41,83.53,9.56Zm-2.61,6.69a2.66,2.66,0,0,0,2.66-2.64v-.08A2.71,2.71,0,0,0,81,10.76a2.58,2.58,0,0,0-2.59,2.58c0,.07,0,.13,0,.19a2.53,2.53,0,0,0,2.34,2.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3853",
    "data-name": "Path 3853",
    className: "cls-1",
    d: "M95.1,14.78l2.12-.42c.07.24.13.45.2.65a2.09,2.09,0,0,0,2.66,1.31,2.3,2.3,0,0,0,.5-.24,1.57,1.57,0,0,0,.68-1.74,1.48,1.48,0,0,0-1.39-1.05c-.26,0-.53,0-.8,0h-.79a9.09,9.09,0,0,1,0-1.88h.87a4.89,4.89,0,0,0,.85-.08,1.29,1.29,0,0,0,1.09-1.11,1.42,1.42,0,0,0-.62-1.51,2,2,0,0,0-2.75.56,3.17,3.17,0,0,0-.21.41c-.08.25-.13.51-.21.8l-2.06-.42a3.7,3.7,0,0,1,1.13-2.6,4.46,4.46,0,0,1,6.08.13,3.69,3.69,0,0,1,.56,3.68,7.55,7.55,0,0,1-.83,1.12.13.13,0,0,0,0,.07c1.76,1,1.5,3.83.07,5a4.51,4.51,0,0,1-3.43,1,4.06,4.06,0,0,1-2.82-1.3A3.6,3.6,0,0,1,95.1,14.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3854",
    "data-name": "Path 3854",
    className: "cls-1",
    d: "M53.17,13.44a5,5,0,1,1,5,4.9,2.09,2.09,0,0,1-.25,0,4.76,4.76,0,0,1-4.8-4.72A1.09,1.09,0,0,1,53.17,13.44Zm5,2.81a2.67,2.67,0,0,0,2.63-2.71h0a2.64,2.64,0,0,0-5.27-.27.89.89,0,0,0,0,.23,2.66,2.66,0,0,0,2.56,2.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3855",
    "data-name": "Path 3855",
    className: "cls-1",
    d: "M49,4.87h2.3V18.1H49C48.87,17.59,48.81,6.1,49,4.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3856",
    "data-name": "Path 3856",
    className: "cls-1",
    d: "M88.65,4.91H91V18.06H88.7C88.56,17.58,88.5,6,88.65,4.91Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2629",
    "data-name": "Group 2629"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3866",
    "data-name": "Path 3866",
    className: "cls-2",
    d: "M14,3.65l-2.79,8.23a6,6,0,0,0,1.11.46l2.1-6.19,3.86,5a6.2,6.2,0,0,0,.84-.86Zm9.3,12a5.54,5.54,0,0,0-1,.71l3.37,4.36-5.14.53a6,6,0,0,0,.29,1.18l7.11-.74ZM8.82,22.5l2-5.95a6.63,6.63,0,0,0-1.15-.35L7.08,23.88,15.84,23a8,8,0,0,0-.24-1.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3867",
    "data-name": "Path 3867",
    className: "cls-3",
    d: "M20.81,22.46l-5,.51a8,8,0,0,0-.24-1.18l4.92-.51A6,6,0,0,0,20.81,22.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3868",
    "data-name": "Path 3868",
    className: "cls-2",
    d: "M12.26,12.34l-1.42,4.21a6.91,6.91,0,0,0-1.15-.35l1.46-4.33A6.72,6.72,0,0,0,12.26,12.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3869",
    "data-name": "Path 3869",
    className: "cls-4",
    d: "M23.25,15.68a5.19,5.19,0,0,0-1,.71l-4.06-5.25a6.2,6.2,0,0,0,.84-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3870",
    "data-name": "Path 3870",
    className: "cls-2",
    d: "M20.47,6.32a6.29,6.29,0,1,1,0-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3871",
    "data-name": "Path 3871",
    className: "cls-1",
    d: "M15.9,24A7.95,7.95,0,1,1,8,16a7.77,7.77,0,0,1,1.73.19,6.63,6.63,0,0,1,1.15.35A7.94,7.94,0,0,1,15.9,24Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3872",
    "data-name": "Path 3872",
    className: "cls-4",
    d: "M31.69,20.52a5.61,5.61,0,0,1-10.88,1.94,5.36,5.36,0,0,1-.29-1.18,5.61,5.61,0,1,1,11.11-1.52A4.87,4.87,0,0,1,31.69,20.52Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2628",
    "data-name": "Group 2628"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2627",
    "data-name": "Group 2627"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3857",
    "data-name": "Path 3857",
    className: "cls-1",
    d: "M96.22,22.42H98c1.58,0,2.53.51,2.53,1.94s-.94,2-2.49,2H96.7v3h-.49ZM97.9,26c1.42,0,2.1-.47,2.1-1.62s-.7-1.53-2.15-1.53H96.71V26Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3858",
    "data-name": "Path 3858",
    className: "cls-1",
    d: "M101.29,26.86a2.43,2.43,0,0,1,2.22-2.68c1.2,0,1.94.86,1.94,2.35a1.7,1.7,0,0,1,0,.39h-3.66a2,2,0,0,0,1.91,2.2,2.28,2.28,0,0,0,1.37-.46l.19.36a2.78,2.78,0,0,1-1.6.5A2.4,2.4,0,0,1,101.29,26.86Zm3.72-.33c0-1.3-.59-2-1.5-2a1.9,1.9,0,0,0-1.74,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3859",
    "data-name": "Path 3859",
    className: "cls-1",
    d: "M106.83,24.31h.4l0,1h0a1.78,1.78,0,0,1,1.45-1.08,1.08,1.08,0,0,1,.5.11l-.1.42a1.21,1.21,0,0,0-.46-.08c-.46,0-1,.35-1.39,1.31V29.4h-.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3860",
    "data-name": "Path 3860",
    className: "cls-1",
    d: "M109.55,28.82l.27-.34a2.36,2.36,0,0,0,1.62.64c.8,0,1.21-.46,1.21-1S112,27.2,111.41,27c-.77-.27-1.63-.59-1.63-1.45s.59-1.36,1.64-1.36a2.42,2.42,0,0,1,1.46.53l-.25.34a2,2,0,0,0-1.22-.47c-.79,0-1.15.46-1.15.93s.6.8,1.21,1c.78.3,1.66.56,1.66,1.55a1.51,1.51,0,0,1-1.59,1.44h-.13A2.85,2.85,0,0,1,109.55,28.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3861",
    "data-name": "Path 3861",
    className: "cls-1",
    d: "M114,26.86a2.31,2.31,0,1,1,4.57,0,2.31,2.31,0,1,1-4.57,0Zm4.08,0c0-1.34-.77-2.27-1.8-2.27s-1.79.93-1.79,2.27.77,2.25,1.79,2.25,1.8-.91,1.8-2.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3862",
    "data-name": "Path 3862",
    className: "cls-1",
    d: "M120.14,24.31h.4l0,.79h0a2.55,2.55,0,0,1,1.75-.92c1,0,1.54.64,1.54,2V29.4h-.47V26.2c0-1.08-.34-1.6-1.16-1.6-.6,0-1,.32-1.66,1V29.4h-.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3863",
    "data-name": "Path 3863",
    className: "cls-1",
    d: "M125.78,24.31h.39l0,.79h0a2.53,2.53,0,0,1,1.75-.92c1.05,0,1.54.64,1.54,2V29.4h-.47V26.2c0-1.08-.34-1.6-1.16-1.6-.61,0-1,.32-1.66,1V29.4h-.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3864",
    "data-name": "Path 3864",
    className: "cls-1",
    d: "M131,26.86a2.43,2.43,0,0,1,2.22-2.68c1.21,0,2,.86,2,2.35a2.56,2.56,0,0,1,0,.39h-3.66a2,2,0,0,0,1.92,2.2,2.28,2.28,0,0,0,1.37-.46l.19.36a2.78,2.78,0,0,1-1.6.5A2.41,2.41,0,0,1,131,26.86Zm3.73-.33c0-1.3-.59-2-1.5-2a1.91,1.91,0,0,0-1.75,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3865",
    "data-name": "Path 3865",
    className: "cls-1",
    d: "M136.53,28.72V21.78H137v7c0,.22.09.33.22.33l.19,0,.07.38a.91.91,0,0,1-.33.05C136.74,29.52,136.53,29.27,136.53,28.72Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPersonnelColor);
export default __webpack_public_path__ + "static/media/logo_personnel_color.c2480fd5ad308675c51c46db05794b75.svg";
export { ForwardRef as ReactComponent };